<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" title="Abbreviations">
<h2 class="fmhead"><a id="page_ix"></a>Abbreviations</h2>
<table class="tab1">
<tbody>
<tr>
<td style="width:20%">AFP</td>
<td style="width:80%">Armed Forces of the Philippines (Philippines)</td>
</tr>
<tr>
<td>ASEAN</td>
<td>Association of Southeast Asian Nations</td>
</tr>
<tr>
<td>Baperki</td>
<td>Badan Permusyawaratan Kewarganegaraan (Consultative Body for Indonesian Citizenship)</td>
</tr>
<tr>
<td>BCP</td>
<td>Burma Communist Party</td>
</tr>
<tr>
<td>BLDP</td>
<td>Buddhist Liberal Democratic Party (Cambodia)</td>
</tr>
<tr>
<td>BSPP</td>
<td>Burma Socialist Program Party</td>
</tr>
<tr>
<td>BTI</td>
<td>Barisan Tani Indonesia (Indonesian Peasants’ Front)</td>
</tr>
<tr>
<td>CAC</td>
<td>Cabinet Action Committee (Philippines)</td>
</tr>
<tr>
<td>CCP</td>
<td>Chinese Communist Party</td>
</tr>
<tr>
<td>CGDK</td>
<td>Coalition Government of Democratic Kampuchea</td>
</tr>
<tr>
<td>CMC</td>
<td>Citizens’ Mendiola Commission (Philippines)</td>
</tr>
<tr>
<td>CPK</td>
<td>Communist Party of Kampuchea</td>
</tr>
<tr>
<td>CPP</td>
<td>Cambodian People’s Party</td>
</tr>
<tr>
<td>CPT</td>
<td>Communist Party of Thailand</td>
</tr>
<tr>
<td>CRPP</td>
<td>Committee Representing People’s Parliament (Myanmar)</td>
</tr>
<tr>
<td>CSOC</td>
<td>Communist Suppression Operations Command (Thailand)</td>
</tr>
<tr>
<td>DLP</td>
<td>Democratic Liberal Party (Korea)</td>
</tr>
<tr>
<td>ECCC</td>
<td>Extraordinary Chambers in the Court of Cambodia</td>
</tr>
<tr>
<td>EDSA</td>
<td>Epifanio de los Santos Avenue (Philippines)</td>
</tr>
<tr>
<td>FUNCINPEC</td>
<td>Front Uni National pour un Cambodge Indépendant, Neutrale, Pacifique, et Coopératif (National United Front for an Independent, Neutral, Peaceful, and Cooperative Cambodia)</td>
</tr>
<tr>
<td>IATFAR</td>
<td>Inter-Agency Task Force on Agrarian Reform (Philippines)</td>
</tr>
<tr>
<td>IPKI</td>
<td>Ikatan Pendukung Kemerdekaan Indonesia (League of Upholders of Indonesian Independence)</td>
</tr>
<tr>
<td>ISOC</td>
<td>Internal Security Operations Command (Thailand)</td>
</tr>
<tr>
<td><a id="page_x"></a>KCIA</td>
<td>Korean Central Intelligence Agency</td>
</tr>
<tr>
<td>KMP</td>
<td>Kilusang Magbubukid ng Pilipinas (Farmers Movement of the Philippines)</td>
</tr>
<tr>
<td>KNU</td>
<td>Karen National Union (Myanmar)</td>
</tr>
<tr>
<td>Komnas HAM</td>
<td>Komisi Nasional Hak Asasi Manusia (Indonesian National Commission on Human Rights)</td>
</tr>
<tr>
<td>KOTI</td>
<td>Supreme Operations Command (Indonesia)</td>
</tr>
<tr>
<td>KPNLF</td>
<td>Khmer People’s National Liberation Front</td>
</tr>
<tr>
<td>MPRS</td>
<td>Majelis Permusyawaratan Rakyat Sementara (People’s Consultative Assembly) (Indonesia)</td>
</tr>
<tr>
<td>NBI</td>
<td>National Bureau of Investigation (Philippines)</td>
</tr>
<tr>
<td>NDF</td>
<td>National Democratic Front (Myanmar)</td>
</tr>
<tr>
<td>NHK</td>
<td>Nippon Hoso Kyokai (Japan Broadcasting Corporation)</td>
</tr>
<tr>
<td>NLD</td>
<td>National League for Democracy (Myanmar)</td>
</tr>
<tr>
<td>NPA</td>
<td>New People’s Army (Philippines)</td>
</tr>
<tr>
<td>NSCT</td>
<td>National Student Center of Thailand</td>
</tr>
<tr>
<td>NSL</td>
<td>National Security Law (Korea)</td>
</tr>
<tr>
<td>NU</td>
<td>Nahdlatul Ulama (Indonesia)</td>
</tr>
<tr>
<td>NUP</td>
<td>National Union Party (Myanmar)</td>
</tr>
<tr>
<td>PKI</td>
<td>Partai Komunis Indonesia (Indonesian Communist Party)</td>
</tr>
<tr>
<td>PNI</td>
<td>Partai Nasional Indonesia (Indonesian National Party)</td>
</tr>
<tr>
<td>PRRI</td>
<td>Pemerintahan Revolusioner Republik Indonesia</td>
</tr>
<tr>
<td>RIT</td>
<td>Rangoon Institute of Technology</td>
</tr>
<tr>
<td>RPKAD</td>
<td>Resimen Para Komando Angkatan Darat (Kostrad and Army Para Commando Regiment) (Indonesia)</td>
</tr>
<tr>
<td>SLORC</td>
<td>State Law and Order Restoration Council (Myanmar)</td>
</tr>
<tr>
<td>SNLD</td>
<td>Shan National League for Democracy (Myanmar)</td>
</tr>
<tr>
<td>SOC</td>
<td>State of Cambodia</td>
</tr>
<tr>
<td>SPDC</td>
<td>State Peace and Development Council (Myanmar)</td>
</tr>
<tr>
<td>SPT</td>
<td>Socialist Party of Thailand</td>
</tr>
<tr>
<td>SWC</td>
<td>Special Warfare Command (Korea)</td>
</tr>
<tr>
<td>TRC</td>
<td>Truth and Reconciliation Committee (South Africa)</td>
</tr>
<tr>
<td>UF</td>
<td>United Front against Dictatorship (Thailand)</td>
</tr>
<tr>
<td>UNTAC</td>
<td>United Nations Transitional Authority in Cambodia</td>
</tr>
<tr>
<td>USCAR</td>
<td>United States Civil Administration of the Ryukyu Islands (Japan)</td>
</tr>
<tr>
<td><a id="page_xi"></a>USDA</td>
<td>Union Solidarity and Development Association (Myanmar)</td>
</tr>
<tr>
<td>USDP</td>
<td>Union Solidarity and Development Party (Myanmar)</td>
</tr>
<tr>
<td>VOA</td>
<td>Voice of America<a id="page_xii"></a></td>
</tr>
</tbody>
</table>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?3c6dd41a